import { httpRequest } from '@lib';
import { useMutation } from '@tanstack/react-query';
import { downloadFileGeneric } from '@utils/general';

const fetchDownloadURL = async ({ downloadUrl, fileName }) => {
  try {
    const { data } = await httpRequest.get(downloadUrl, {
      ignoreAuthToken: true,
    });
    await downloadFileGeneric(data?.data, `${fileName}.pdf`);
    return data.data;
  } catch (err) {
    throw new Error(err);
  }
};

export const useFetchDownloadURLQuery = () => useMutation({
  mutationFn: fetchDownloadURL,
});
